import gtmhelpers from '@/commons/gtmhelpers';

const trackedItems: any = {};

export default (vuexstore: any) => {
    vuexstore.subscribe((mutation: any, state: any) => {
        const current = state.route.name;

        if (mutation.type === 'cart/setCart') {
            const {items} = mutation.payload;
            const cartHash = JSON.stringify(items.map((i: any) => i.item_id + i.qty));

            // eslint-disable-next-line no-prototype-builtins
            if (current === 'cart' && !trackedItems.hasOwnProperty(cartHash)) {
                trackedItems[cartHash] = true;
                gtmhelpers.trackCheckout(gtmhelpers.convertProductsData(items), '', '1');
            }
        }

        if (mutation.type === 'checkout/flagStep') {
            const {items} = state.cart.cart;
            let step: string = '';

            switch (mutation.payload.stepName) {
                case 'shipping':
                    step = '2';
                    break;
                case 'invoice':
                    step = '3';
                    break;
                default:
                    break;
            }

            if (step !== '') {
                gtmhelpers.trackCheckout(gtmhelpers.convertProductsData(items), '', step);
            }
        }
    });
};
